import { EdfCoaches, EdfStaffs } from '../directus';
import { CardPlayerInfo } from '@/components/types';
import getDirectusImageUrl from '../utils/image';

export default function mapCampaignStaffToPlayerCard(
  data: Array<EdfStaffs>,
): Array<CardPlayerInfo> {
  let roles = {
    'entraineur': 1,
    'assistant': 2,
    'preparateur_physique': 4,
  }
  let sortedData = data
    .sort((a, b) => {
      return (a.order || 100) - (b.order || 100);
    })
    .sort((a, b) => {
      let a_role_value = 1000;
      if (a.role && roles[a.role as keyof typeof roles]) {
        a_role_value = roles[a.role as keyof typeof roles];
      }
      let b_role_value = 1000;
      if (b.role && roles[b.role as keyof typeof roles]) {
        b_role_value = roles[b.role as keyof typeof roles];
      }
      return (a_role_value || 100) - (b_role_value || 100);
    });

  return sortedData.map(({ coach, club, role, photo }) => {
    const staffInfo = coach as EdfCoaches;
    const photoUrl = photo
      ? getDirectusImageUrl(photo as string, true, 600, 600, 'inside', 'avif')
      : '';
    return {
      title: staffInfo?.first_name || '',
      fullName: `${staffInfo?.first_name} ${staffInfo?.last_name}`,
      callToActionUrl: {
        url: '',
        external: false,
      },
      clubName: club || '',
      image: photoUrl || '',
      position: role ? (role[0].toUpperCase() + role.slice(1)).replace('_', ' ').replace('reparateur', 'réparateur') : '',
      number: -1,
      man: staffInfo.gender === '1',
      selected: true,
    };
  });
}
